/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-useless-escape */
export const ValidateCharecters = function(data:string)
{
	const re = /^([a-zA-Z ]+)$/;

	return re.test(data);
};
export const ValidateConfigCharacters = function(data:string)
{
	const re = /^[\w\s.-]+@?[\w.-]*$/;

	return re.test(data);
};
export const ValidateDegreeCharecters = function(data:string)
{
	const re = /^([a-zA-Z ]+(.?[a-zA-Z ]+.?)*)$/;

	return re.test(data);
};
export const ValidateUniversityCharecters = function(data:string)
{
	// const re = /^(([a-zA-Z ]+\.?)+(\([a-zA-Z ]+((-?[a-zA-Z ]+)*(\&?[a-zA-Z ]+)*)*\))?)$/;
	const re = /^(?!.*(?:\s{2}|\-{2}|[.,()]{2})).*[a-zA-Z\s&(),.-]+$/;

	return re.test(data);
};

export const ValidateCharactersIntegers = function(data)
{
	const re = /^([a-zA-Z0-9 ]{0,12})*$/;

	return re.test(data);
};

export const ValidateIntegers = function(data:string)
{
	const re = /^([0-9]+)$/;

	return re.test(data);
};

export const ValidateEmail = function(data:string)
{
	// const re =
	//   /^((([a-zA-Z]|[0-9])|([-]|[_]|[.])){1,})+[@](([a-zA-Z0-9])|([-]|[.])){2,40}[.]((([a-zA-Z0-9]){2,10})|(([a-zA-Z0-9]){2,4}[.]([a-zA-Z0-9]){2,4}))$/;
	const re = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/gm;

	return re.test(data);
};

export const ValidatePassword = (data:string) =>
{
	const regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*:]).{6,}$/;

	return regex.test(data);
};

export const ValidateIsNotempty = (data:string) =>
{
	return data && data.trim() !== '';
};
export const ValidateCategory = (data:string) =>
{
	const regex = /^[ A-Za-z0-9_.&-]*$/;

	return regex.test(data);
};
export const ValidateYoutubeurl = (url:any) =>
{
	const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|v=|\?v=)([^#?]*).*/;
	const match = url.match(regExp);

	return match;
};
export const ValidatePincode = (data) =>
{
	const re = /^([0-9]{6,10})$/;

	return re.test(data);
};

export const ValidateWebsite = (data) =>
{
	const re =
	/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;

	return re.test(data);
};

export const ValidateDomainName = (data) =>
{
	const re = /^@[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/;

	return re.test(data);
};

export const ValidateDomain = function(data:string)
{
	const re =
      /^[@](([a-zA-Z0-9])|([-]|[.])){2,40}[.]((([a-zA-Z0-9]){2,10})|(([a-zA-Z0-9]){2,4}[.]([a-zA-Z0-9]){2,4}))$/;

	return re.test(data);
};

export const ValidateUrl = (data) =>
{
	const re = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;

	return re.test(data);
};

export const IsValidURL = (url) =>
{
	try
	{
		return Boolean(new URL(url));
	}
	catch (e)
	{
		return false;
	}
};

export const validateCompanyName = (data) =>
{
	// const regex = /^[ A-Za-z0-9_.&-]*$/;
	// const regex = /^[.@&]?[a-zA-Z0-9 ]+[ !.@&()]?[ a-zA-Z0-9!()]+/;
	// const regex = /^[A-Za-z][A-Za-z0-9\s&.,-]+$/;
	const regex = /^[A-Za-z0-9&.\-@#,+\s]+$/;

	return regex.test(data);
};

export const ValidateSignDesignation = (data) =>
{
	// const regex = /^[ A-Za-z0-9_.&-]*$/;
	// const regex = /^[.@&]?[a-zA-Z0-9 ]+[ !.@&()]?[ a-zA-Z0-9!()]+/;
	const regex = /^[A-Za-z\s&,'.]+$/;

	return regex.test(data);
};

export const validateMobile = (data) =>
{
	// const regex = /^(?:\+\d{1,3}[-\s]?)?(?:\d{10,15})$/
	const regex = /^[+]?(\d+[+]?)?[+]?\d*$/;

	// const regex = /^[ A-Za-z0-9_.&-]*$/;
	// const regex = /^[.@&]?[a-zA-Z0-9 ]+[ !.@&()]?[ a-zA-Z0-9!()]+/;
	// const regex = /^[A-Za-z][A-Za-z0-9\s&.,'-]+$/;

	return regex.test(data);
};
export const validateEmployeeId = (data) =>
{
	const regex = /^\d{1,10}$/;

	return regex.test(data);
};

export const ValidateNoOfSeats = (data) =>
{
	const regex = /^\d*$/;

	return regex.test(data);
};
export const validateCompany = (data) =>
{
	const regex = /^[a-zA-Z0-9\s@&.]*$/;

	return regex.test(data);
};

export const validateYoutubeDomain = (url:any) =>
{
	const regExp = /^https?:\/\/(www\.)?youtube\.com\/?$/;
	const match = url.match(regExp);

	return match;
};
export const validateFacebookDomain = (url: any) =>
{
	const regExp = /^https?:\/\/(www\.)?facebook\.com\/?/;
	const match = url.match(regExp);

	return match;
};

export const validateLinkedinDomain = (url: any) =>
{
	const regExp = /^https?:\/\/(www\.)?linkedin\.com\/?/;
	const match = url.match(regExp);

	return match;
};

export const validateTwitterDomain = (url: any) =>
{
	const regExp = /^https?:\/\/(www\.)?twitter\.com\/?/;
	const match = url.match(regExp);

	return match;
};

export const validateInstagramDomain = (url: any) =>
{
	const regExp = /^https?:\/\/(www\.)?instagram\.com\/?/;
	const match = url.match(regExp);

	return match;
};
